var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21348 12.6543C2.8541 12.9837 2.83913 13.3281 3.16855 13.6875C3.52793 14.0169 3.87233 14.002 4.20176 13.6426L8.1998 9.68945L12.1979 13.6426C12.5273 14.002 12.8567 14.0169 13.1861 13.6875C13.5455 13.3281 13.5455 12.9837 13.1861 12.6543L9.23301 8.65625L13.1861 4.6582C13.5455 4.32878 13.5455 3.99935 13.1861 3.66992C12.8567 3.31055 12.5273 3.31055 12.1979 3.66992L8.1998 7.62305L4.20176 3.66992C3.87233 3.31055 3.52793 3.31055 3.16855 3.66992C2.83913 3.99935 2.8541 4.32878 3.21348 4.6582L7.1666 8.65625L3.21348 12.6543Z",
    fill: "#2A467B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b05e15d9b9cdd43059f1801b14dbabf6.svg";
export { ForwardRef as ReactComponent };